<template>
  <v-container>
    <h2 class="display-1 font-weight-bold px-3">Edit Your Profile</h2>
    <sign-on edit></sign-on>
  </v-container>
</template>

<script>
    import SignOn from "@/pages/SignOn";

    export default {
        name: "EditProfile",
        components: {SignOn}
    }
</script>

<style scoped>

</style>
